export const GETTER_ADVISOR_ACCOUNTS = "GETTER_ADVISOR_ACCOUNTS";
export const ACTION_GET_ADVISOR_ACCOUNTS = "ACTION_GET_ADVISOR_ACCOUNTS";
export const MUTATION_SET_ADVISOR_ACCOUNTS = "MUTATION_SET_ADVISOR_ACCOUNTS";

export default {
    namespaced: true,
    GETTER_ADVISOR_ACCOUNTS,
    ACTION_GET_ADVISOR_ACCOUNTS,
    MUTATION_SET_ADVISOR_ACCOUNTS
};